import { useState } from "react"
import ReactMarkdown from "react-markdown"

interface Props {
  content: string
  maxWords?: number
  useMarkdown?: boolean
}

const Collapsible = ({ content, maxWords = 60, useMarkdown = true }: Props) => {
  const [open, setOpen] = useState(false)
  const words = content ? content.split(" ") : []
  const truncated = words.slice(0, maxWords).join(" ")
  const overflows = words.length > maxWords
  const displayText = open ? content : overflows ? `${truncated}...` : truncated

  return (
    <div>
      {useMarkdown ? (
        <div className="prose prose-sm max-w-none text-gallery-text leading-relaxed [&_p]:mb-3 [&_p:last-child]:mb-0">
          <ReactMarkdown>{displayText}</ReactMarkdown>
        </div>
      ) : (
        <p className="text-sm leading-relaxed text-gallery-text">
          {displayText}
        </p>
      )}
      {overflows && !open && (
        <button
          onClick={() => setOpen(true)}
          className="mt-2 gallery-label text-gallery-muted hover:text-gallery-text transition-colors underline-offset-2 underline"
        >
          Read more
        </button>
      )}
    </div>
  )
}

export default Collapsible
